var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 7.57143C11.1429 7.41964 11.0804 7.27679 10.9732 7.16964L6.97321 3.16964C6.86607 3.0625 6.72321 3 6.57143 3C6.25893 3 6 3.25893 6 3.57143V11.5714C6 11.8839 6.25893 12.1429 6.57143 12.1429C6.72321 12.1429 6.86607 12.0804 6.97321 11.9732L10.9732 7.97322C11.0804 7.86607 11.1429 7.72321 11.1429 7.57143Z",
    fill: "#5A8FC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/ArrowRightIcon.c0b0852c98839b825d401e332b1d399a.svg";
export { ForwardRef as ReactComponent };